import React from 'react'
import { Box, Flex } from 'rebass'
import styled from 'styled-components'
import StripeCheckout from 'react-stripe-checkout'
import Select from 'react-select'
import uuidv4 from 'uuid/v4'

export const Donation = styled(Box)`
  font-size: 1rem;
  max-width: 32rem;
  line-height: 1.3;
  border-bottom: 1px solid;
  .react-select-container {
    flex-grow: 1;
    margin-right: 0.5rem;
  }
`

export const DonateButton = styled.button`
  background: #4bc169;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  width: 100%;
  ${props =>
    props.disabled &&
    `
    opacity: 0.3;
    pointer-events: none;
  `};
  &:hover,
  &:focus {
    opacity: 0.6;
    cursor: pointer;
  }
`

const options = [
  { value: 1000, label: '€10' },
  { value: 2500, label: '€25' },
  { value: 5000, label: '€50' },
  { value: 10000, label: '€100' },
  { value: 50000, label: '€500' },
  { value: 100000, label: '€1000' },
]

class Donatation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedOption: { value: 1000, label: '€10' },
    }
    this.onToken = this.onToken.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  onToken(token) {
    console.log('on token')
    console.log(token)
    console.log(
      JSON.stringify({
        token,
        amount: this.state.selectedOption.value,
        idempotency_key: uuidv4(),
      })
    )
    fetch(`/.netlify/functions/purchase-eu`, {
      method: 'POST',
      body: JSON.stringify({
        token,
        amount: this.state.selectedOption.value,
        idempotency_key: uuidv4(),
      }),
    })
      .then(res => res.json())
      .catch(error => console.error('Error:', error))
      .then(response => console.log(response))
  }

  handleChange(selectedOption) {
    this.setState({ selectedOption })
    console.log(`Option selected:`, selectedOption)
  }

  render() {
    const { selectedOption } = this.state
    return (
      <Donation
        id="donation-element"
        mx={['-1.5rem', '-3rem', '-1.5rem', '-3rem']}
        px={['1.5rem', '3rem', '1.5rem', '3rem']}
        pb={['1.5rem', '3rem', '1.5rem', '3rem']}
      >
        <Flex flex={{ flexDirection: 'row', flex: '1 0 auto' }}>
          <Select
            value={selectedOption || { value: 1000, label: '€10' }}
            onChange={this.handleChange}
            options={options}
            placeholder="Choose an amount..."
            className="react-select-container"
          />
          <StripeCheckout
            token={selectedOption && this.onToken}
            currency="EUR"
            amount={(selectedOption && selectedOption.value) || 1000}
            name="Donation to TNOC—Europe"
            panelLabel="Donate"
            stripeKey={process.env.GATSBY_STRIPE_PUBLISHABLE_KEY}
          >
            <DonateButton>Donate</DonateButton>
          </StripeCheckout>
        </Flex>
      </Donation>
    )
  }
}

export default Donatation



// WEBPACK FOOTER //
// ./src/components/Donation.js